import React from "react";
import {ColumnsType} from "antd/es/table";
import "./HistoryExamine.scss";
import dayjs from "dayjs";
import {trangThaiPKOptions} from "assets/constants/select-catagory-options";
import {FORMAT_TIME} from "types/enums";

const listHistoryColumns: ColumnsType = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    render: (text, record, index) => index + 1,
    width: 70,
    align: "center",
  },
  {
    title: "Mã phiếu",
    dataIndex: "idPhieu",
    key: "idPhieu",
    width: 70,
    align: "center",
  },
  {
    title: "Tên phiếu",
    dataIndex: "tenPhieu",
    align: "left",
    key: "tenPhieu",
    width: 200,
  },
  {
    title: "Thời gian tạo",
    dataIndex: "thoiGianTao",
    key: "thoiGianTao",
    align: "center",
    render: (v, r, i) => (v ? dayjs(v).format(FORMAT_TIME.dateTime) : null),
    width: 150,
  },
  {
    title: "Thời gian hoàn thành",
    dataIndex: "thoiGianHoanThanh",
    key: "thoiGianHoanThanh",
    align: "center",
    width: 150,
    render: (v, r, i) => (v ? dayjs(v).format(FORMAT_TIME.dateTime) : null),
  },
  {
    title: "Trạng thái hoạt động",
    dataIndex: "trangThai",
    key: "trangThai",
    render: (v, r, i) =>
      trangThaiPKOptions.find(it => it.value === v)?.label || "",
    width: 150,
  },
  {
    title: "Người thực hiện",
    dataIndex: "nguoiThucHien",
    key: "nguoiThucHien",
    width: 150,
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    width: 70,
  },
];

export {listHistoryColumns};
